export default "__VITE_ASSET__B6XwEjxM__"